import type { FC } from 'react';

import { ComponentsHead } from '@/components/head';
import { AddOnsTemplate } from '@/components/add-ons/template';
import { LinkWithTitle } from '@/components/links';
import { AnchorWithTitle } from '@/components/links/anchor';

export const MEMORIAL_DAY_TITLE = 'Memorial Day';

export const Head = () => {
  return (
    <ComponentsHead
      title="Tampa Memorial Day Boat Charter | Summer Starts Here"
      description="Celebrate Memorial Day weekend with friends and sunshine on the water. Book your Tampa Bay boat charter for the summer’s first big party."
      keywords="Memorial Day, Summer Kickoff, Tampa Charter, Boat Party"
    />
  );
};

const SpecialEventsMemorialDay: FC = () => {
  return (
    <AddOnsTemplate
      title="Memorial Day Weekend Boat Charters – Kick Off Summer on the Water"
      subtitle="Memorial Day Weekend Boat Charters – Kick Off Summer on the Water"
    >
      <h3>Reflect and Relax on the Water</h3>
      <p>
        Honor and celebrate Memorial Day with a relaxing
        cruise through Tampa Bay. As Memorial Day is one of
        the busiest weekends, it is the perfect time to
        escape the crowds and enjoy a peaceful day at sea.
        Whether you want to commemorate the holiday with
        family and friends or simply soak up the Florida sun
        while listening to the calm water, our private
        charters provide a sophisticated and serene setting.
      </p>
      <p>
        On the day, we depart from the David Island Boat
        Ramp. Our{' '}
        <LinkWithTitle to="/services/">
          4 hour Memorial Day Cruise
        </LinkWithTitle>{' '}
        travels peacefully through the stunning waters of
        Tampa Bay. From the cruise, you will see views of{' '}
        <AnchorWithTitle href="https://thetampariverwalk.com/">
          downtown Tampa
        </AnchorWithTitle>
        , Davis Islands and the open bay. We can plan in
        occasional stops near sandbars and beautiful beaches
        for you to take full advantage of the great weather
        we have this time of year.
      </p>
      <h4>Cruise in Comfort</h4>
      <p>
        <LinkWithTitle to="/our-boat/">
          Choose from the TBBA Adventure{' '}
        </LinkWithTitle>
        for up to 12 guests or the Paradiso for larger
        groups up to 30. Each charter includes a
        professional captain, comfortable shaded seating, a
        premium sound system, coolers with ice and bottled
        water, and the option a number of add ons such as
        catered meals.
      </p>
      <p>
        Given the popularity of Memorial Day weekend, we
        highly recommend booking your charter well in
        advance. Whether you’re looking for a quiet retreat
        or a celebratory gathering on the water, our
        Memorial Day charters provide the perfect balance of
        relaxation and remembrance.
      </p>
    </AddOnsTemplate>
  );
};

export default SpecialEventsMemorialDay;
